<!--
 * @Author: Shen Kui
 * @Description: 对象信息
-->
<template>
  <div class="absolute h-[calc(100%-140px)] w-540px left-35px top-66px z-100">
    <el-tooltip
      :content="showPanel ? '收缩三维寻阀' : '展开三维寻阀'"
      placement="right"
      :open-delay="1000"
    >
      <div
        class="w-34px h-34px rounded-tl-2px rounded-tr-5px rounded-br-5px
          rounded-bl-2px bg-[#00c0ff] top-0px -left-34px text-center
          cursor-pointer absolute text-[#fff]"
        @click="showPanel = !showPanel"
      >
        <span class="iconfont icon-bg-setup text-18px !leading-34px"></span>
      </div>
    </el-tooltip>
    <div class="p-10px component-container h-full" v-show="showPanel">
      <div
        class="text-hex-fff text-24px h-46px w-full bg-no-repeat flex items-center py-10px px-10px"
      >
        三维寻阀
      </div>
      <div class="flex">
        <selectStandardId
          @updateStandardId="updateStandardId"
          class="!w-140px"
          :selectStandardProps="{ popperClass: 'document_select-popper' }"
        />
        <el-select
          class="w-full ml-10px flex-1"
          v-model="modelDocumentId"
          popper-class="document_select-popper"
          clearable
          filterable
          size="mini"
          placeholder="模型下拉选择"
          @change="changeCurrentModel"
        >
          <el-option
            v-for="item in modelList"
            :key="item.id"
            :label="item.fileNameOrigin"
            :value="item.documentId"
          ></el-option>
        </el-select>
      </div>
      <div class="flex mt-10px items-center">
        <el-input
          v-model="keyword"
          size="mini"
          class="mr-10px !w-140px"
          placeholder="请输入代码或名称"
          @keyup.enter.native="searchList"
          clearable
        ></el-input>
        <el-input
          v-model="discipline"
          size="mini"
          class="mr-10px flex-1"
          placeholder="请输入专业"
          @keyup.enter.native="searchList"
          clearable
        ></el-input>
        <el-tooltip effect="dark" content="搜索" placement="top" :open-delay="1000">
          <el-button
            type="primary"
            @click="searchList"
            icon="iconfont icon-line-search"
          ></el-button>
        </el-tooltip>
        <el-tooltip effect="dark" content="对象信息" placement="top" :open-delay="1000">
          <el-button
            type="primary"
            @click="$emit('showBitRelational')"
            icon="iconfont icon-bg-language"
          ></el-button>
        </el-tooltip>
        <el-tooltip
          effect="dark"
          content="介质流向设置"
          placement="top"
          :open-delay="1000"
          v-if="isAdmin"
        >
          <el-button
            type="primary"
            @click="openSetupDialog"
            icon="iconfont icon-bg-setup"
          ></el-button>
        </el-tooltip>
      </div>
      <el-table
        ref="markerTable"
        :data="tableData"
        v-loading="tableLoading"
        height="calc(100% - 178px)"
        :row-key="(row) => row.tagId"
        class="mt-10px"
        :cell-style="{ 'text-align': 'center' }"
        :header-cell-style="{ 'text-align': 'center' }"
        :highlight-current-row="true"
        @row-click="moveToPipe"
      >
        <el-table-column show-overflow-tooltip prop="tagCode" label="代码"></el-table-column>
        <el-table-column show-overflow-tooltip prop="tagName" label="名称"></el-table-column>
        <el-table-column show-overflow-tooltip prop="medium" label="介质"> </el-table-column>
        <el-table-column show-overflow-tooltip prop="discipline" label="专业"></el-table-column>
      </el-table>
      <div class="mt-10px text-right">
        <el-pagination
          small
          background
          @current-change="getTableData"
          :current-page.sync="page.pageNo"
          :page-size.sync="page.pageSize"
          layout="total, prev, pager, next"
          :total="page.total"
          :pager-count="5"
        ></el-pagination>
      </div>
    </div>
    <el-dialog
      :visible.sync="setupDialogVisible"
      title="寻阀规则设置"
      width="800px"
      :modal="false"
      v-dialogDrag
    >
      <el-form
        :model="setupForm"
        :rules="setupRules"
        label-width="100px"
        class="max-h-440px overflow-y-auto"
        ref="setupFormRef"
      >
        <el-form-item label="规则类型" prop="ruleType" label-width="70px">
          <el-select
            v-model="setupForm.ruleType"
            placeholder="请选择规则类型"
            clearable
            filterable
            popper-class="document_select-popper"
            @change="changeType"
            class="w-260px"
          >
            <el-option
              v-for="item in ruleList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <div>
          <div class="text-white">类别范围设置</div>
          <div class="mt-10px border-1px border-solid border-[#0680e9] rounded-5px px-10px pt-20px">
            <el-form-item label="类别代码" prop="classIds">
              <el-select
                v-model="setupForm.classIds"
                multiple
                placeholder="类别代码_类别名称"
                clearable
                filterable
                class="w-full"
                popper-class="document_select-popper"
                :disabled="setupForm.ruleType === 1"
              >
                <el-option
                  v-for="item in classList"
                  :key="item.id"
                  :label="`${item.code}_${item.name}`"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </div>
          <div class="mt-10px flex items-center justify-between">
            <span class="text-white">管线子节点条件设置</span>
            <div>
              <el-button
                type="primary"
                size="mini"
                @click="addCondition"
                :disabled="setupForm.ruleType === 0"
                >添加</el-button
              >
              <el-button
                type="danger"
                size="mini"
                @click="deleteCondition"
                :disabled="setupForm.ruleType === 0"
                >删除</el-button
              >
            </div>
          </div>
          <div class="mt-10px border-1px border-solid border-[#0680e9] rounded-5px px-10px pt-20px">
            <el-form-item label="节点阀条件" prop="condition">
              <el-input
                v-model="setupForm.condition"
                placeholder="%valve%"
                class="w-full"
                :disabled="setupForm.ruleType === 0"
              />
            </el-form-item>
          </div>
          <el-row
            class="mt-10px border-1px border-solid border-[#0680e9] rounded-5px px-10px pt-20px"
            v-for="(item, index) in setupForm.moreCondition"
            :key="index"
          >
            <el-col :span="6">
              <el-form-item label="" :rules="conditionRules">
                <div slot="label" class="inline-block">
                  <el-checkbox
                    v-model="item.isChecked"
                    :disabled="setupForm.ruleType === 0"
                  ></el-checkbox>
                  <span class="ml-5px">条件逻辑</span>
                </div>
                <el-select
                  v-model="item.operation"
                  placeholder="请选择条件逻辑"
                  popper-class="document_select-popper"
                  @change="changeType"
                >
                  <el-option
                    v-for="item in operationList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="18">
              <el-form-item
                label="节点阀条件"
                :prop="`moreCondition.${index}.express`"
                :rules="conditionRules"
              >
                <el-input
                  v-model="item.express"
                  placeholder="%v-%"
                  class="w-full"
                  :disabled="setupForm.ruleType === 0"
                />
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </el-form>
      <div slot="footer" class="text-center">
        <el-button size="small" type="primary" @click="saveSetup">保存</el-button>
        <el-button size="small" @click="setupDialogVisible = false">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import DocumentManagementService from '@/services/documentManagement'
import ThreeDimensionsService from '@/services/ThreeDimensions'
import DocumentConfigService from '@/services/documentConfigService'
import ApiMixinDocument from '@/assets/js/api/documents'
import selectStandardId from '@/modules/resource/components/selectStandardId'
import { find } from 'lodash'

export default {
  name: 'valveSeeking',
  mixins: [ApiMixinDocument],
  components: {
    selectStandardId,
  },
  props: {
    player: {
      type: Object,
      default: () => {
        return {}
      },
    },
    cloudRender: {
      type: Object,
      default: () => {
        return {}
      },
    },
  },
  data() {
    return {
      showPanel: true,
      standardId: localStorage.getItem('standardId'),
      modelDocumentId: '',
      modelList: [], // 模型列表
      keyword: '',
      discipline: '',
      allModelList: [], // 所有模型列表
      tableData: [],
      page: {
        pageNo: 1,
        pageSize: 15,
        total: 0,
      },
      tableLoading: false,
      setupDialogVisible: false,
      setupForm: {
        ruleType: undefined,
        classIds: [],
        condition: '',
        moreCondition: [],
      },
      ruleList: [
        { value: 0, label: '类别数据上下级数据' },
        { value: 1, label: '模型管线子节点数据' },
        { value: 2, label: '类别数据上下级+管线子节点并集' },
      ],
      classList: [],
      operationList: [
        { value: 'or', label: '或' },
        { value: 'and', label: '与' },
      ],
    }
  },
  computed: {
    isAdmin() {
      if (window.__POWERED_BY_QIANKUN__) {
        const currentUser = JSON.parse(localStorage.getItem('CurrentUser'))
        return find(currentUser?._Roles, { Name: '超级管理员' }) || currentUser.Level >= 999
      }
      const currentUser = Wiz.AuthHooks.GetUserInfo()
      return currentUser?.profile.role.includes('超级管理员')
    },
    setupRules() {
      return {
        ruleType: [{ required: true, message: '请选择规则类型', trigger: 'change' }],
        classIds: [
          {
            required: [0, 2].includes(this.setupForm.ruleType),
            message: '请选择规则类型',
            trigger: 'change',
          },
        ],
        condition: [
          {
            required: [1, 2].includes(this.setupForm.ruleType),
            message: '请输入节点阀条件',
            trigger: 'blur',
          },
        ],
      }
    },
    conditionRules() {
      return [
        {
          required: [1, 2].includes(this.setupForm.ruleType),
          message: '请输入节点阀条件',
          trigger: 'blur',
        },
      ]
    },
  },
  methods: {
    changeType() {
      if (this.setupForm.ruleType === 0) {
        this.setupForm.moreCondition = []
        this.setupForm.condition = ''
      } else if (this.setupForm.ruleType === 1) {
        this.setupForm.classIds = []
      }
      this.$nextTick(() => {
        this.$refs.setupFormRef.clearValidate()
      })
    },
    addCondition() {
      this.setupForm.moreCondition.push({
        isChecked: false,
        express: '',
        operation: 'or',
      })
    },
    deleteCondition() {
      this.setupForm.moreCondition = this.setupForm.moreCondition.filter((item) => {
        return !item.isChecked
      })
    },
    async openSetupDialog() {
      this.setupDialogVisible = true
      this.setupForm = this.$options.data().setupForm
      this.$nextTick(() => {
        this.$refs.setupFormRef.clearValidate()
      })
      const res = await ThreeDimensionsService.getValveSettings({
        standardId: this.standardId,
      })
      if (res?.code === 0 && res.data.standardId) {
        this.setupForm = {
          ruleType: res.data.ruleType,
          classIds: res.data.ruleType === 1 ? [] : res.data.classIds,
          condition: res.data.ruleType === 0 ? '' : res.data.regexPatterns?.condition,
          moreCondition:
            res.data.ruleType === 0
              ? []
              : res.data.regexPatterns?.moreCondition.map((item) => {
                  return {
                    isChecked: false,
                    operation: item.operation,
                    express: item.express,
                  }
                }),
        }
      }
    },
    async saveSetup() {
      this.$refs.setupFormRef.validate(async (valid) => {
        let regexPatterns = null
        if ([1, 2].includes(this.setupForm.ruleType)) {
          regexPatterns = {
            condition: this.setupForm.condition,
            moreCondition: this.setupForm.moreCondition.map((item) => {
              return {
                operation: item.operation,
                express: item.express,
              }
            }),
          }
        }
        if (valid) {
          const res = await ThreeDimensionsService.updateValveSettings({
            standardId: this.standardId,
            ruleType: this.setupForm.ruleType,
            classIds: this.setupForm.classIds,
            regexPatterns,
          })
          if (res?.code === 0) {
            this.$message.success('保存成功')
            this.setupDialogVisible = false
          }
        }
      })
    },
    async getClassList() {
      const res = await DocumentConfigService.getTagTypeClass({
        standardId: this.standardId,
      })
      if (res?.code === 0) {
        this.classList = res.data
      }
    },
    async searchList() {
      this.page.pageNo = 1
      await this.resetData()
      this.getTableData()
    },
    // 获取管线表数据
    async getTableData() {
      this.tableData = []
      this.tableLoading = true
      const res = await ThreeDimensionsService.getPipeLineList({
        pageNo: this.page.pageNo,
        pageSize: this.page.pageSize,
        standardId: this.standardId,
        modelFileId: this.modelDocumentId
          ? _.find(this.modelList, ['documentId', this.modelDocumentId]).fileIdOrigin
          : '',
        filter: this.keyword,
        discipline: this.discipline,
      })

      if (res?.code === 0) {
        this.tableData = res.data
        this.page.total = res.totalCount
      }
      this.tableLoading = false
    },
    // 重置数据
    async resetData() {
      // 首先将选中的模型节点取消选中
      const hiddenNodes = await this.player.Native.Node.getSeletedNodes()
      if (hiddenNodes && !_.isEmpty(hiddenNodes)) {
        await this.player.Native.Node.unSelectNodes(hiddenNodes)
      }
      await this.cloudRender.Marker.destroyAllMarker()
      this.player.Native.GisMarker.EventGisMarkerHover.disconnect(this.markerHover)
      this.player.Native.GisMarker.EventGisMarkerLeave.disconnect(this.markerLeave)
      this.tableData = []
    },
    updateStandardId(val) {
      this.standardId = val
      this.modelList = _.filter(this.allModelList, ['standardId', this.standardId])
      this.modelDocumentId = this.modelList?.[0].documentId || ''
      this.changeCurrentModel(this.modelDocumentId)
      this.getClassList()
    },
    // 切换模型
    async changeCurrentModel(val) {
      // 获取model详情
      const model = await this.getModelFileDetail(val)
      if (!_.isEmpty(model)) {
        this.$emit('changeModelData', model)
      }
      this.searchList()
    },
    /**
     * @description: 获取文件详情
     * @param {*}
     * @return {*}
     */

    async getModelFileDetail(id) {
      const res = await DocumentManagementService.getDocumentDetail({
        id,
        standardId: this.standardId,
      })
      if (res && res.code === 0 && res.data) {
        let fileDetail = {}

        _.forEach(res.data.files, (file) => {
          if (res.data.documentBaseInfo.defaultFileId === file.fileIdOrigin) {
            fileDetail = file
          }
        })
        if (_.isEmpty(fileDetail)) {
          return {}
        }
        // 文件id
        fileDetail.fileId = res.data.documentBaseInfo.defaultFileId
        fileDetail.classId = res.data.documentBaseInfo.classId
        // 拼接模板属性
        fileDetail.attrObject = {}
        const templateAttr = _.find(this.systemParams, (item) => {
          return item.parameterCode === 'MultipleModelTemplate'
        })
        if (!_.isEmpty(res.data.templateAttrSetList) && templateAttr) {
          const attr = _.filter(res.data.templateAttrSetList, (el) => {
            return el.attributeTemplate.code === templateAttr.parameterValue
          })
          if (!_.isEmpty(attr)) {
            _.forEach(attr[0].attrValueList, (Attr) => {
              fileDetail.attrObject[Attr.fieldName] = Attr.attrValue
            })
          }
        }
        // 提取文件类型
        fileDetail.type = _.last(_.split(fileDetail.fileName, '.')).toLowerCase()
        return fileDetail
      }
      return {}
    },
    async getModelList() {
      const res = await this.apiDocuments({
        method: 'baseDocumentModel',
        params: {
          id: this.documentId,
        },
      })
      if (res && res.code === 0 && res.data && res.data.length) {
        return res.data
      }
      return []
    },
    async markerHover(item) {
      const newimgId = await this.player.Native.GisMarker.loadImage('rgba:0,0,0,127')
      if (item.markerId !== 0) {
        await this.player.Native.GisMarker.setProperty(item.markerId, {
          imgId: newimgId,
          textColor: 0xffffffff,
        })
      }
    },
    async markerLeave(item) {
      // 创建一个透明的图片，用于隐藏
      const imgId = await this.player.Native.GisMarker.loadImage('rgba:0,0,0,0')
      await this.player.Native.GisMarker.setProperty(item.markerId, {
        imgId,
        textColor: 0xffffff00,
      })
    },
    async moveToPipe(row) {
      await this.cloudRender.Marker.destroyAllMarker()
      this.player.Native.GisMarker.EventGisMarkerHover.disconnect(this.markerHover)
      this.player.Native.GisMarker.EventGisMarkerLeave.disconnect(this.markerLeave)
      if (row.tagCode) {
        this.$emit('getModelData', {
          isTag: true,
          businessId: row.tagId,
          code: row.tagCode,
          codeChangeType: 'pickUpengineId', // 避免触发ModelView中的moveCamera，动画节点会覆盖原始节点导致选中不生效
        })
        this.$emit('showRightPanel', {
          component: 'valveSeekingDetail',
          transferProps: {
            ...row,
            standardId: this.standardId,
          },
        })
        const rootNode = await this.player.Native.Node.getRoot()
        const codeData = await this.player.Native.Node.findNode(rootNode, {
          codes: [row.tagCode],
        })
        const codes = codeData?.codes
        if (codes && codes[row.tagCode] && codes[row.tagCode].node) {
          // 计算节点包围盒
          const nodeInfo = await this.player.Native.Node.getProperty(codes[row.tagCode].node, [
            'aabb',
          ])
          const calculateValue = (aabb) => {
            const minPoint = aabb[0]
            const maxPoint = aabb[1]

            const dx = maxPoint[0] - minPoint[0]
            const dy = maxPoint[1] - minPoint[1]
            const dz = maxPoint[2] - minPoint[2]

            const L = Math.sqrt(dx ** 2 + dy ** 2 + dz ** 2)
            const value = 0 + 6.5 / (1 + Math.log(L + 1))
            return value
          }
          // 相机移动到包围盒位置
          this.player.Native.Camera.moveToAabbWithDistance(
            nodeInfo.aabb,
            2,
            25,
            calculateValue(nodeInfo.aabb)
          )
          this.player.Native.Node.selectNodes([codes[row.tagCode].node])
          this.player.Native.GisMarker.EventGisMarkerHover.connect(this.markerHover)
          this.player.Native.GisMarker.EventGisMarkerLeave.connect(this.markerLeave)
          const nodeResult = await this.cloudRender.NodeProxy.getInfo('Code', row.tagCode)
          if (nodeResult.status) {
            const nodeData = nodeResult.data.nodeInfo
            const text = `Code: ${nodeData.code}`
            const aabb = nodeData.aabb
            const pos = []
            pos[0] = aabb[0][0] + (aabb[1][0] - aabb[0][0]) * 0.5 // x坐标
            pos[1] = aabb[0][1] + (aabb[1][1] - aabb[0][1]) * 0.5 // y坐标
            pos[2] = aabb[0][2] + (aabb[1][2] - aabb[0][2]) // z坐标
            await this.cloudRender.Marker.createBySingleLine({
              id: row.tagCode,
              pos,
              background: 'transparent',
              visible: true,
              text,
              textColor: '#ffffffff',
              nodeOffset: [0, -60],
              markPosType: 1,
            })
          }
        }
      }
    },
  },
  async created() {
    this.allModelList = await this.getModelList()
    if (this.standardId) {
      this.modelList = _.filter(this.allModelList, ['standardId', this.standardId])
      this.modelDocumentId = this.modelList?.[0].documentId || ''
      this.changeCurrentModel(this.modelDocumentId)
      this.getClassList()
    }
  },
  async beforeDestroy() {
    const rootNode = await this.player.Native.Node.getRoot()
    if (rootNode) {
      await this.player.Native.Node.setProperty(rootNode, { visible: true })
    }
  },
}
</script>

<style lang="scss" scoped>

@import '../../documentBrowseVk/css/index.scss';

.component-container,
::v-deep .el-dialog {
  background-image: url('../../../../resource/assets/images/container_bg.png');
  background-size: 100% 100%;
}
::v-deep .el-dialog {
  background-color: transparent !important;
  .el-dialog__header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom-color: #0680e9;
    .el-dialog__title {
      font-size: 24px;
      line-height: 40px;
    }
    .el-dialog__headerbtn .el-dialog__close {
      color: #fff !important;
    }
  }
  .el-dialog__body {
    overflow-y: hidden !important;
    .el-input.is-disabled .el-input__inner {
      background-color: transparent !important;
    }
  }
  .el-dialog__footer {
    background-color: transparent;
    border-top-color: #0680e9;
  }
}

</style>
